export const products = [
  {
    id: 1,
    title: 'Halo Desk',
    price: 541800,
    description: 'Precision lines, soft depth, and a calm silhouette for focused work.',
    accent: 'from-[#f7d488] via-[#f0b37e] to-[#e88b73]',
    orb: 'bg-[#fff1d0]',
    panel: 'bg-white/30',
  },
  {
    id: 2,
    title: 'Luma Stand',
    price: 394800,
    description: 'A compact statement piece with balanced geometry and warm presence.',
    accent: 'from-[#93c5fd] via-[#7dd3fc] to-[#6ee7b7]',
    orb: 'bg-[#dff6ff]',
    panel: 'bg-white/20',
  },
  {
    id: 3,
    title: 'Nova Shelf',
    price: 789600,
    description: 'Layered storage language designed to feel light, quiet, and premium.',
    accent: 'from-[#f0abfc] via-[#f9a8d4] to-[#fdba74]',
    orb: 'bg-[#fce7f3]',
    panel: 'bg-white/25',
  },
  {
    id: 4,
    title: 'Drift Lamp',
    price: 302400,
    description: 'Soft glow aesthetics shaped into a restrained, architectural form.',
    accent: 'from-[#bef264] via-[#86efac] to-[#5eead4]',
    orb: 'bg-[#ecfccb]',
    panel: 'bg-white/25',
  },
  {
    id: 5,
    title: 'Aero Console',
    price: 697200,
    description: 'Streamlined proportions with elevated finishes for client-facing spaces.',
    accent: 'from-[#c4b5fd] via-[#a78bfa] to-[#818cf8]',
    orb: 'bg-[#ede9fe]',
    panel: 'bg-white/20',
  },
  {
    id: 6,
    title: 'Form Stool',
    price: 495600,
    description: 'A sculpted utility object with a crisp visual rhythm and soft edges.',
    accent: 'from-[#67e8f9] via-[#60a5fa] to-[#38bdf8]',
    orb: 'bg-[#cffafe]',
    panel: 'bg-white/20',
  },
  {
    id: 7,
    title: 'Frame Mirror',
    price: 609000,
    description: 'Reflective balance with clean perimeter detailing and subtle depth.',
    accent: 'from-[#fda4af] via-[#f9a8d4] to-[#e879f9]',
    orb: 'bg-[#ffe4e6]',
    panel: 'bg-white/25',
  },
  {
    id: 8,
    title: 'Cloud Tray',
    price: 243600,
    description: 'Minimal serving form with rounded expression and tactile softness.',
    accent: 'from-[#fde68a] via-[#fef3c7] to-[#fdba74]',
    orb: 'bg-[#fffbeb]',
    panel: 'bg-white/35',
  },
  {
    id: 9,
    title: 'Line Cabinet',
    price: 890400,
    description: 'Confident volume and refined contrast built for modern interiors.',
    accent: 'from-[#6ee7b7] via-[#5eead4] to-[#67e8f9]',
    orb: 'bg-[#d1fae5]',
    panel: 'bg-white/20',
  },
  {
    id: 10,
    title: 'Echo Bowl',
    price: 205800,
    description: 'A small decorative surface with gallery-like restraint and polish.',
    accent: 'from-[#a5b4fc] via-[#c4b5fd] to-[#d8b4fe]',
    orb: 'bg-[#e0e7ff]',
    panel: 'bg-white/25',
  },
  {
    id: 11,
    title: 'Axis Table',
    price: 739200,
    description: 'Purposeful proportions and a sophisticated material-inspired palette.',
    accent: 'from-[#fdba74] via-[#fb7185] to-[#f472b6]',
    orb: 'bg-[#fff7ed]',
    panel: 'bg-white/20',
  },
  {
    id: 12,
    title: 'Arc Bench',
    price: 646800,
    description: 'Curved geometry softened with subtle highlights and graceful balance.',
    accent: 'from-[#38bdf8] via-[#818cf8] to-[#c084fc]',
    orb: 'bg-[#e0f2fe]',
    panel: 'bg-white/20',
  },
];
